import { useGlobal } from '@/utils/useGlobal';
import Nav from './components/Nav';
import styles from './index.module.scss';
import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import { getProductData } from '@elem/utils/getProductData';
import { useEffect, useState } from 'react';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { generalKey } from './config/pageConfig';

const Support = () => {
    const { useRouter, gloproductlist } = useGlobal();

    const { locale } = useRouter();

    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });

    const [productDataA, setProductDataA] = useState<any>(null);

    const getProductDataHandle = async () => {
        const productPageData = await getProductData(productMsg, locale);
        setProductDataA(productPageData);
    };

    useEffect(() => {
        getProductDataHandle();
    }, []);

    return (
        <div className={styles.FAQ}>
            <Nav theme="white" />
            {productDataA && <ProductSupport supportData={productDataA.supportData} spuId={productDataA.spuId} theme="white" />}
        </div>
    );
};

export default Support;
